export const VOLUNTEER = "VOLUNTEER"
export const ASSOCIATION = "ASSOCIATION"
